import { FTLang, LANGUAGE_TYPE } from "src/utils";
import LangOptionList, { Lang } from "./lang-option-list";
import siteIdEnum, {
  languageBySiteId,
  languageBySiteIdFull
} from "./siteIdEnum";

import { ReactComponent as HelpIcon } from "src/assets/svg/morelink/help.svg";
import { ReactComponent as LanguageIcon } from "src/assets/svg/morelink/Language.svg";
import { ReactComponent as PenIcon } from "src/assets/svg/morelink/Pen.svg";
import { Popover } from "antd";
import React from "react";
import { SHOW_LANGUAGE_ARRAY } from "src/constant";
import { ReactComponent as ThreeIcon } from "src/assets/svg/morelink/threedoticon.svg";
import clsx from "clsx";
// import WhatsAppIcon from 'src/assets/svg/morelink/WhatsApp.svg';
import languageData from "./languageData";
import styles from "./FTMoreLink.module.scss";
import { useLanguage } from "src/hooks";

interface IProps {
  showAd?: boolean;
}
export default function FTMoreLink(props: IProps) {
  const { showAd } = props;
  const [isFullScreen, setIsFullScreen] = React.useState(false);
  const { t, changeLanguage, languageNum, languageKey } = useLanguage();
  const data = [
    {
      key: "help",
      icon: <HelpIcon />,
      languageKey: "more_link_help"
    },
    {
      key: "feedback",
      icon: <PenIcon />,
      languageKey: "more_link_feedback"
    },
    // {
    //   key: "whatapp",
    //   icon: <WhatsAppIcon />,
    //   languageKey: "video_more_link_whatapp"

    // },
    {
      key: "language",
      icon: <LanguageIcon />,
      languageKey: "more_link_language"
    }
  ];

  const langList = React.useMemo(() => {
    return (
      languageData[languageNum]
        ?.map((item) => ({
          key: languageBySiteId[item.key],
          fullKey: languageBySiteIdFull[item.key],
          name: item.title,
          nativeName: item.name
        }))
        .filter((item) => SHOW_LANGUAGE_ARRAY.includes(item.fullKey)) ?? []
    );
  }, [languageNum]);

  const handleClickItem = (type: string) => {
    switch (type) {
      case "help":
        window.open("https://support.fotor.com/hc/en-us", "_blank");
        break;
      case "feedback":
        window.open(
          "https://support.fotor.com/hc/en-us/requests/new",
          "_blank"
        );
        break;
      // case "whatapp":
      //   window.open("https://www.fotor.com/zh-cn/feedback", "_blank");
      //   break;
      default:
        break;
    }
  };

  const handleChangeLanguage = (lang: Lang) => {
    const siteId = siteIdEnum[lang.key];
    changeLanguage(languageBySiteIdFull[siteId] as any);
  };

  React.useEffect(() => {
    const show = () => {
      setIsFullScreen(true);
    };
    const hide = () => {
      setIsFullScreen(false);
    };
    window.addEventListener("fullscreenchange", show);
    window.addEventListener("unfullscreenchange", hide);
    return () => {
      window.removeEventListener("fullscreenchange", show);
      window.removeEventListener("unfullscreenchange", hide);
    };
  }, []);
  const arrowProps = {
    arrow: false
  } as any;
  return (
    <div
      onClick={(e) =>{e.stopPropagation(); e.preventDefault()}}
      className={clsx(styles.FTMoreLink_box, showAd && styles.showCountryAd)}
      style={{ display: isFullScreen ? "none" : "block" }}>
      <Popover
        {...arrowProps}
        align={{ offset: [0, 0] }}
        placement='topRight'
        overlayClassName={styles["custom_help_popover"]}
        overlayInnerStyle={{
          padding: "8px",
          borderRadius: "4px",
          width: "236px"
        }}
        content={
          <div className={styles.innerBox}>
            {data.map((item) => {
              if (item.key === "language") {
                return (
                  <Popover
                    key={item.key}
                    overlayClassName={styles["custom_popover"]}
                    {...arrowProps}
                    placement='leftBottom'
                    trigger='hover'
                    align={{ offset: [-8, 8] }}
                    content={
                      <LangOptionList
                        langList={langList}
                        activeKey={languageKey?.toLocaleLowerCase()}
                        onChange={handleChangeLanguage}
                      />
                    }>
                    <div className={styles.innerBox_item} key={item.key}>
                      {item.icon}
                      <span>{t(item.languageKey)}</span>
                    </div>
                  </Popover>
                );
              } else {
                return (
                  <div
                    className={styles.innerBox_item}
                    key={item.key}
                    onClick={() => {
                      handleClickItem(item.key);
                    }}>
                    {item.icon}
                    <span>{t(item.languageKey)}</span>
                  </div>
                );
              }
            })}
          </div>
        }>
        <div className={styles.icon_box}>
          <ThreeIcon width={18} />
        </div>
      </Popover>
    </div>
  );
}
